import { useEffect } from 'react'

import { ping } from 'api/auth'

import useUser from './useUser'

export default function useKeepSessionAlive() {
    const { isLoggedIn } = useUser()

    useEffect(() => {
        if (!isLoggedIn) return

        const intervalId = setInterval(() => {
            ping().catch()
        }, 60000)

        return () => clearInterval(intervalId)
    }, [isLoggedIn])
}
